import { Calendar } from '@fullcalendar/core'
import dayGridPlugin from '@fullcalendar/daygrid'
import $ from 'jquery'
import './main.scss'

const initializeFullCalendar = () =>
  $('.upcoming-events-calendar--uninitialized').each(function () {
    const $this = $(this)

    let occurrences = $this.data('occurrences')
    const firstDayOfWeek = $this.data('first-day-of-week')

    occurrences = occurrences.map((occurrence) => ({
      id: occurrence.id,
      group_id: occurrence.event_id || undefined,
      title: occurrence.title,
      url: occurrence.url,
      start: new Date(occurrence.starts_at_unix * 1000),
      end: new Date(occurrence.ends_at_unix * 1000),
    }))

    const noOfWeeksToShow = $this.data('no-of-weeks')
    const noVerticalScroll = $this.data('no-vertical-scroll')
    const locale = $this.data('locale')
    const timeFormat24h = $this.data('time-format-24h')
    const timeSettings = { meridiem: 'lowercase', hour12: true }

    if (timeFormat24h) {
      timeSettings.hour12 = false
      timeSettings.meridiem = false
    }

    const height = noVerticalScroll || noOfWeeksToShow <= 5 ? 'auto' : undefined

    let calendar = new Calendar(this, {
      plugins: [dayGridPlugin],
      initialView: 'multiMonth',
      selectable: true,
      firstDay: firstDayOfWeek,
      headerToolbar: false,
      events: occurrences,
      eventDisplay: 'list-item',
      dateIncrement: { weeks: 1 },
      locale: locale,

      eventClick: function (info) {
        info.jsEvent.preventDefault()

        if (info.event.url) {
          // Inside the mobile app's WebView, a new-window request from a click target the
          // native handler can't hit-test silently does nothing (ENG-34417) — navigate the
          // WebView itself there instead. Defense-in-depth: this chip renders as a real
          // `<a href>` (FullCalendar's `eventDisplay: 'list-item'` sets `href` from `event.url`),
          // so it may already be safe, but guarding costs nothing.
          if (document.documentElement.classList.contains('turbo-native')) {
            window.location.href = info.event.url
          } else {
            window.open(info.event.url)
          }
        }
      },
      views: {
        multiMonth: {
          type: 'dayGrid',
          duration: { weeks: noOfWeeksToShow },
          eventTimeFormat: {
            hour: 'numeric',
            minute: '2-digit',
            omitZeroMinute: true,
            ...timeSettings,
          },
        },
      },
      height,
      dayCellDidMount(day) {
        const { date } = day
        if (date.getDate() === 1) {
          return day.el.classList.add('start-of-month-cell')
        }
      },
    })

    calendar.render()
    const calendarContainer = $this.parent()
    const scrollUpBtn = calendarContainer.find('.scroll-up')
    scrollUpBtn.on('click', () => {
      calendar.prev()
    })
    const scrollDownBtn = calendarContainer.find('.scroll-down')
    scrollDownBtn.on('click', () => {
      calendar.next()
    })
    $this.removeClass('upcoming-events-calendar--uninitialized')

    return $(document).on('simplero:section:unload', () => (calendar = null))
  })

$(document).on('simplero:section:load', initializeFullCalendar)
$(initializeFullCalendar)
